// src/slices/contact/thunk.js
import {
    setLoading,
    setContacts,
    setContactDetails,
    setError,
    setPagination,
} from "./reducer";
import { getAllContacts, getContactById } from "../../helpers/apis";

// ✅ Fetch all contacts with pagination support
export const fetchAllContacts = (config = {}) => async (dispatch) => {
    try {
        console.log("fetchAllContacts thunk called with config:", config);
        
        dispatch(setLoading(true));
        
        const limit = config.limit || config.perPage || 10;
        const page = config.page || config.currentPage || 1;
        
        // Update pagination state before API call
        dispatch(setPagination({
            page: page,
            pageSize: limit
        }));
        
        // Backend returns: { success, message, data, pagination }
        const response = await getAllContacts({
            page,
            limit,
            search: config.search || "",
            orderBy: config.orderBy || "createdAt",
            order: config.order || "desc",
        });
        
        console.log("API Response:", response);
        
        // Check if response is successful - Backend returns 'success: true', not 'status: 1'
        if (response && (response.success === true || response.status === 1)) {
            // Update pageSize in the response since backend doesn't return it
            const responseWithPageSize = {
                ...response,
                pagination: {
                    ...response.pagination,
                    itemsPerPage: limit, // Add pageSize from request
                }
            };
            dispatch(setContacts(responseWithPageSize));
        } else {
            const errorMsg = response?.message || "Failed to fetch contacts";
            console.error("API returned error:", errorMsg);
            dispatch(setError(errorMsg));
            dispatch(setContacts({ data: [], pagination: null }));
        }
    } catch (error) {
        console.error("Error fetching contacts:", error);
        dispatch(setError(error.message || "Failed to fetch contacts"));
        dispatch(setContacts({ data: [], pagination: null }));
    } finally {
        dispatch(setLoading(false));
    }
};

export const fetchContactById = (id) => async (dispatch) => {
    try {
        dispatch(setLoading(true));
        console.log("Fetching contact by ID:", id); // Debug log
        
        // API returns: { status, message, data, ... }
        const response = await getContactById(id);
        
        console.log("Contact details response:", response); // Debug log
        
        if (response && response.status === 1) {
            // Backend returns contact directly in 'data' field
            const contactData = response.data || null;
            dispatch(setContactDetails(contactData));
        } else {
            dispatch(setError(response?.message || "Contact not found"));
            dispatch(setContactDetails(null));
        }
    } catch (err) {
        console.error("Error fetching contact details:", err);
        dispatch(setError(err.message || "Failed to fetch contact details"));
        dispatch(setContactDetails(null));
    } finally {
        dispatch(setLoading(false));
    }
};